<template lang="pug">
    main#app
        router-view
        Footer
</template>

<script>
import Footer from '@components/Footer/Footer'

export default {
    name: "template-only-footer",
    components: {
        Footer
    }
}
</script>

<style lang="stylus" scoped src="./OnlyFooter.styl"></style>